/*
 * @Author       : suzhen
 * @Email        : suzhen@dianzhong.com
 * @Date         : 2022-09-19 11:42:43
 * @LastEditors: suzhen suzhen@dianzhong.com
 * @LastEditTime: 2024-04-19 10:09:11
 * @Description  : 文件简介
 */
import { createRouter, createWebHistory } from 'vue-router'

// 活动路由 custom
const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/index.vue'),
    meta: {
      withoutLogin: true,
      keepAlive: false,
      title: '登录'
    }
  },
  {
    path: '/joinlogin',
    name: 'joinlogin',
    component: () => import('@/views/login/joinLogin.vue'),
    meta: {
      withoutLogin: true,
      keepAlive: false,
      title: '登录'
    }
  },
  {
    path: '/dowload',
    name: 'dowload',
    component: () => import('@/views/login/dowload.vue'),
    meta: {
      withoutLogin: true,
      keepAlive: false,
      title: '下载'
    }
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/home/index.vue'),
    meta: {
      keepAlive: true,
      title: '首页'
    }
  },
  {
    path: '/bookDetail',
    name: 'bookDetail',
    component: ()=> import('@/views/home/bookDetail.vue'),
    meta: {
      keepAlive: false,
      title: '书籍详情'
    }
  },
  {
    path: '/planDetail',
    name: 'planDetail',
    component: ()=> import('@/views/home/planDetail.vue'),
    meta: {
      keepAlive: false,
      title: '计划详情'
    }
  },
  
  {
    path: '/notice/:id',
    name: 'notice',
    component: ()=> import('@/views/home/notice.vue'),
    meta: {
      keepAlive: false,
      title: '公告'
    }
  },
  {
    path: '/videoList',
    name: 'videoList',
    component: ()=> import('@/views/home/videoList.vue'),
    meta: {
      keepAlive: false,
      title: '更多短剧'
    }
  },
  {
    path: '/list',
    name: 'List',
    component: () => import('@/views/list/index.vue'),
    meta: {
      keepAlive: false,
      title: '推广列表'
    }
  },
  {
    path: '/table',
    name: 'Table',
    component: () => import('@/views/table/index.vue'),
    meta: {
      keepAlive: true,
      title: '收益'
    }
  },
  {
    path: '/tdata',
    name: 'Data',
    component: () => import('@/views/tdata/index.vue'),
    meta: {
      keepAlive: false,
      title: '数据'
    }
  },
  {
    path: '/webpage',
    name: 'webpage',
    component: () => import('@/views/list/webpage.vue'),
    meta: {
      keepAlive: false,
      title: '网页转换'
    }
  },
  {
    path: '/mine',
    name: 'Mine',
    component: () => import('@/views/mine/index.vue'),
    meta: {
      keepAlive: false,
      title: '我的'
    }
  },
  {
    path: '/withdrawalall',
    name: 'withdrawalall',
    component: () => import('@/views/mine/withdrawalall.vue'),
    meta: {
      keepAlive: false,
      title: '提现记录'
    }
  },
  {
    path: '/userinfo',
    name: 'userinfo',
    component: () => import('@/views/mine/userInfo.vue'),
    meta: {
      keepAlive: false,
      title: '个人信息'
    }
  },
  {
    path: '/videocpstxt',
    name: 'videocpstxt',
    component: () => import('@/views/mine/videocpstxt.vue'),
    meta: {
      keepAlive: false,
      title: '合同信息'
    }
  },
  {
    path: '/contactus',
    name: 'contactus',
    component: () => import('@/views/mine/contactUs.vue'),
    meta: {
      keepAlive: false,
      title: '联系我们'
    }
  },
  {
    path: '/headlevel',
    name: 'headLevel',
    component: () => import('@/views/mine/headLevel.vue'),
    meta: {
      keepAlive: false,
      title: '团队信息'
    }
  },
  {
    path: '/headearnings',
    name: 'headearnings',
    component: () => import('@/views/mine/headearnings.vue'),
    meta: {
      keepAlive: false,
      title: '团队收益'
    }
  },
  {
    path: '/headdrm',
    name: 'headdrm',
    component: () => import('@/views/mine/headdrm.vue'),
    meta: {
      keepAlive: false,
      title: '达人收益'
    }
  },
  {
    path: '/headdata',
    name: 'headdata',
    component: () => import('@/views/mine/headdata.vue'),
    meta: {
      keepAlive: false,
      title: '我的团队'
    }
  },
  {
    path: '/newlist',
    name: 'newlist',
    component: () => import('@/views/mine/newList.vue'),
    meta: {
      keepAlive: false,
      title: '消息记录'
    }
  },
  {
    path: '/earningslist',
    name: 'earningslist',  // 计划废弃
    component: () => import('@/views/mine/earningsList.vue'),
    meta: {
      keepAlive: false,
      title: '收益明细'
    }
  },
  {
    path: '/drawalrecor',
    name: 'drawalrecor',
    component: () => import('@/views/mine/recorList.vue'),
    meta: {
      keepAlive: false,
      title: '提现记录'
    }
  },
  {
    path: '/withdrawal',
    name: 'withdrawal',
    component: () => import('@/views/mine/withdrawal.vue'),
    meta: {
      keepAlive: false,
      title: '提现记录'
    }
  },
  {
    path: '/planwithdrawal',
    name: 'planwithdrawal',
    component: () => import('@/views/table/planwithdrawal.vue'),
    meta: {
      keepAlive: false,
      title: '提现记录'
    }
  },
  {
    path: '/applymony',
    name: 'applymony',
    component: () => import('@/views/mine/applyMony.vue'),
    meta: {
      keepAlive: false,
      title: '申请提现'
    }
  },
  {
    path: '/account',
    name: 'Account',
    component: () => import('@/views/mine/account.vue'),
    meta: {
      keepAlive: false,
      title: '账号管理'
    }
  },
  {
    path: '/addaccount',
    name: 'addAccount',
    component: () => import('@/views/mine/addAccount.vue'),
    meta: {
      keepAlive: false,
      title: '添加账号'
    }
  },
  {
    path: '/sting',
    name: 'Sting',
    component: ()=> import('@/views/mine/sting.vue'),
    meta: {
      keepAlive: false,
      title: '设置'
    }
  },
  {
    path: '/agreement/:type',
    name: 'agreement',
    component: ()=> import('@/views/login/agreement.vue'),
    meta: {
      withoutLogin: true,
      keepAlive: false,
      title: '用户阅读'
    }
  },
  {
    path: '/awardlist',
    name: 'awardList',
    component: () => import('@/views/awardList/index.vue'),
    meta: {
      keepAlive: true,
      title: '星图奖励'
    }
  },
  {
    path: '/awardadd',
    name: 'awardAdd',
    component: () => import('@/views/awardAdd/index.vue'),
    meta: {
      keepAlive: false,
      title: '添加星图奖励'
    }
  },
  {
    path: '/search',
    name: 'search',
    component: ()=> import('@/views/search/index.vue'),
    meta: {
      keepAlive: false,
      title: '搜索'
    }
  },
  // 日收益
  {
    path: '/incomeDetail',
    name: 'incomeDetail',
    component: ()=> import('@/views/incomeDetail/index.vue'),
    meta: {
      title: '收益详情'
    }
  },
  // 单个剧集收益
  {
    path: '/incomePopularize',
    name: 'incomePopularize',
    component: ()=> import('@/views/incomePopularize/index.vue'),
    meta: {
      title: '收益详情'
    }
  },
  {
    path: '/',
    redirect: '/home',
  },
  // {
  //   path: '/:catchAll(.*)',
  //   name: '404',
  //   component: () => import('../views/errPage/404.vue'),
  //   meta: {
  //     keepAlive: false,
  //     title: '404'
  //   }
  // },
  
]

// createWebHashHistory
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
